// Pricing v2 — locale-aware static config for the new `/pricing-v2/` page.
//
// Architecture note: the page is locale-driven via the URL (`/en/`, `/ro/`, ...).
// Each locale resolves to a currency, and each currency has one config entry.
// Adding USD later is a one-line addition under `CONFIG.USD` plus a locale-to-
// currency mapping change in `src/lib/pricing.js` — no component changes needed.

import { currencyForLocale } from "../lib/pricing.js";

// Yearly prices are precomputed (monthly * 12 * 0.8) and rounded — the page
// displays them as monthly equivalents ("X € /month, billed annually"). Storing
// them explicitly keeps the rounding under our control and removes the need to
// do arithmetic in components.
export const PRICING_V2 = {
  RON: {
    currency: "RON",
    currencySymbol: "RON",
    vatLabel: "+ VAT",
    packages: {
      local:        { monthly: 249, yearly: 199 },
      standard:     { monthly: 399, yearly: 319 },
      high_volume:  { monthly: 599, yearly: 479 },
    },
    addons: {
      review_reply: 79,
      live_chat:    99,
    },
    nfc_cards: {
      essential:        90,
      standard:        150,
      pro:             250,
      essential_custom: 180,
      standard_custom:  300,
      pro_custom:       500,
    },
  },
  EUR: {
    currency: "EUR",
    currencySymbol: "€",
    vatLabel: "+ VAT",
    packages: {
      local:        { monthly: 59,  yearly: 47 },
      standard:     { monthly: 99,  yearly: 79 },
      high_volume:  { monthly: 149, yearly: 119 },
    },
    addons: {
      review_reply: 19,
      live_chat:    25,
    },
    nfc_cards: {
      essential:        22,
      standard:         36,
      pro:              60,
      essential_custom: 43,
      standard_custom:  72,
      pro_custom:      120,
    },
  },
  // USD: { ... }  — drop in a config block here when expanding to the US.
};

export function pricingV2ForLocale(locale) {
  const currency = currencyForLocale(locale);
  return PRICING_V2[currency] || PRICING_V2.EUR;
}

// Formats a price for display. Suffix (e.g. "/month") is appended after the
// currency symbol so it inherits the same dim styling we apply in components.
export function formatV2Price(amount, cfg) {
  if (amount == null) return "";
  // RON: number first, then "RON" (matches existing site convention "395 RON").
  if (cfg.currency === "RON") return `${amount} ${cfg.currencySymbol}`;
  // EUR (and USD when added): symbol first ("€99"), western convention.
  return `${cfg.currencySymbol}${amount}`;
}
